import { Link } from "react-router-dom";
import { useLocale } from "@/locale/LocaleContext";
import styles from "./wordmark.module.css";

type Props = {
  to?: string;
  compact?: boolean;
  className?: string;
};

export function Wordmark({ to = "/", compact = false, className }: Props) {
  const { m } = useLocale();
  const content = (
    <>
      <span className={styles.mono} aria-hidden>
        <span className={styles.monoMark}>T</span>
        <span className={styles.monoBar} />
      </span>
      {compact ? (
        <span className="sr-only">{m.brand.name}</span>
      ) : (
        <span className={styles.name}>
          <span className={styles.namePrimary}>Tenqora</span>
          <span className={styles.nameSecondary}>Agent</span>
        </span>
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={[styles.mark, className].filter(Boolean).join(" ")}>
        {content}
      </Link>
    );
  }

  return <span className={[styles.mark, className].filter(Boolean).join(" ")}>{content}</span>;
}
